import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom'; // Import Outlet for nested routes
import Sidebar from '../components/Dashboard/Sidebar';
import { useAuth } from '../contexts/AuthContext';
import Topbar from '../components/Dashboard/Topbar';

const Dashboard = () => {
    const { authData } = useAuth(); // Access authData from AuthContext
    const navigate = useNavigate(); // Initialize navigation

    useEffect(() => {
        if (!authData) {
            // Redirect to the home page if the user is not authenticated
            navigate('/');
        }
    }, [authData, navigate]);

    if (!authData) {
        // Optionally, render a loading or fallback UI while redirecting
        return <div>Redirecting...</div>;
    }

    return (
        <div id="dashboardLayout" class="fixed inset-0 flex">
            <Sidebar />
            <div className="flex-1 flex flex-col">
                <Topbar/>
                <main id="dashboardContent" class="flex-1 overflow-y-auto bg-gray-50 p-6 dashboard-content">
                    <Outlet /> {/* Render the nested routes here */}
                </main>
            </div>
        </div>
    );
};

export default Dashboard;